import { getMerkleIds } from "./getMerkleIds.es.js";
import { logger } from "../../../utils/logger.es.js";
import "../../../cookies-56ad18bd.js";
const analyticsMerkleIds = () => ({
  name: "analytics-merkleId",
  page: async ({ payload }) => {
    try {
      const ids = payload.properties.ids || {};
      const merkleData = await getMerkleIds();
      const allIds = { ...ids, ...merkleData ?? {} };
      payload.properties = {
        ...payload.properties,
        ids: allIds
      };
    } catch (error) {
      logger.error("Failed to process merkle IDs:", error);
    }
  },
  track: async ({ payload }) => {
    try {
      const ids = payload.properties.ids || {};
      const merkleData = await getMerkleIds();
      const allIds = { ...ids, ...merkleData ?? {} };
      payload.properties = {
        ...payload.properties,
        ids: allIds
      };
    } catch (error) {
      logger.error("Failed to process merkle IDs:", error);
    }
  }
});
export {
  analyticsMerkleIds
};
